// extracted by mini-css-extract-plugin
export default {"layout":"style-module_layout__44be7","main":"style-module_main__462a9"};